module.exports = __webpack_public_path__ + "static/media/360_hotspot.75c70311.svg";